module.exports = {
	acl(user, defineAbility) {
		const ability = defineAbility((can, cannot) => {
			if (user.role === 'admin') {
				can('manage', 'Dailyrate');
			} else {
				cannot('manage', 'Dailyrate');
				can('read', 'Dailyrate');
			}
		});

		return { ability };
	}
};
